import React from 'react';
import { Box, Button, Card, CardContent, Divider, Paper, Stack, TextField, Typography } from '@mui/material';
import { ActivityTemplate } from './types';
import TemplateDetailsDialog from './TemplateDetailsDialog';

type Props = {
  // templates: ActivityTemplate[];
  // disabled?: boolean;
  // applying: boolean;
  // onApply: (templateCode: string) => Promise<void>;
  selectedNode: any; 
  saving: boolean;
  activityCode: string;
  activityName: string;
  costCenter: string;
  activityWeight: number;
  activityDescription: string;
  taskCode: string;
  taskName: string;
  taskWeight: number;
  taskDescription: string;
  onFieldChange: (name: string, value: any) => void;
  addActivity: () => void;
  addTask: () => void;

  loading: boolean;
};

export class ActivityFormPanel extends React.Component<Props,any> {

  state = {
    selectedTemplate: null,
    detailsOpen: false,
  };

  render(){
    const { selectedNode, saving } = this.props;
    const { activityCode, activityName, costCenter, activityWeight, activityDescription } = this.props; //this.setTextField('activityCode')
    const { taskCode, taskName, taskWeight, taskDescription } = this.props;
    const { onFieldChange, addActivity, addTask } = this.props;

    console.log('afp.taskCode',taskCode);
    
    const canAddActivity = selectedNode?.nodetype === 'KPI';
    const canAddTask = selectedNode?.nodetype === 'ACTIVITY';

    return (
      <Paper elevation={1} sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Context Actions
        </Typography>

        {selectedNode ? (
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2">
              <strong>Selected:</strong> {selectedNode.nodetype} — {selectedNode.code}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {selectedNode.name}
            </Typography>
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Select a KPI to add an activity or select an activity to add a task.
          </Typography>
        )}

         { canAddActivity && (
          <>
        <Divider sx={{ my: 2 }} />

       
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Add Activity under KPI
        </Typography>

        <Stack spacing={1.5} sx={{ mb: 3 }}>
          <TextField
            size="small"
            label="Activity Code"
            value={activityCode}
            //onChange={(e) => onFieldChange('activityCode',e?.target?.value)}
            disabled={!canAddActivity}
          />

          <TextField
            size="small"
            label="Activity Name"
            value={activityName}
            onChange={(e) => onFieldChange('activityName',e?.target?.value)}
            disabled={!canAddActivity}
          />

          <TextField
            size="small"
            label="Cost Center"
            value={costCenter}
            //onChange={(e) => onFieldChange('costCenter',e?.target?.value)}
            disabled={!canAddActivity}
            helperText="Example: DAI, DSI, DCG"
          />

          <TextField
            size="small"
            label="KPI Contribution Weight"
            type="number"
            value={activityWeight}
            onChange={(e) => onFieldChange('activityWeight',e?.target?.value)}
            disabled={!canAddActivity}
          />

          <TextField
            size="small"
            label="Description"
            value={activityDescription}
            onChange={(e) => onFieldChange('activityDescription',e?.target?.value)}
            disabled={!canAddActivity}
            multiline
            minRows={2}
          />

          <Button
            variant="contained"
            onClick={addActivity}
            disabled={!canAddActivity || saving}
          >
            Add Activity
          </Button>
        </Stack>
          </>
        )}

         { canAddTask && (
          <>
        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Add Task under Activity
        </Typography>

        <Stack spacing={1.5}>
          <TextField
            size="small"
            label="Task Code"
            value={taskCode || `${activityCode}.T`}
            onChange={(e) => onFieldChange('taskCode',e?.target?.value)}
            disabled={!canAddTask}
          />

          <TextField
            size="small"
            label="Task Name"
            value={taskName}
            onChange={(e) => onFieldChange('taskName',e?.target?.value)}
            disabled={!canAddTask}
          />

          <TextField
            size="small"
            label="Task Weight"
            type="number"
            value={taskWeight}
            onChange={(e) => onFieldChange('taskWeight',e?.target?.value)}
            disabled={!canAddTask}
          />

          <TextField
            size="small"
            label="Description"
            value={taskDescription}
            onChange={(e) => onFieldChange('taskDescription',e?.target?.value)}
            disabled={!canAddTask}
            multiline
            minRows={2}
          />

          <Button
            variant="contained"
            color="secondary"
            onClick={addTask}
            disabled={!canAddTask || saving}
          >
            Add Task
          </Button>
        </Stack>
          </>
        )}

      </Paper>
    );
  }
}

export default ActivityFormPanel;
